import { Box, styled, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

const StyleBox = styled(Box)`
  position: relative;

  & > img:nth-of-type(01) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 80%;
  }
`;

const SideContent = ({
  isLarge = false,
  isRight = false,
  className = "",
  children,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <StyleBox
      className={`${
        md ? (isLarge ? "col-8" : "col-4") : "col-12"
      } d-flex flex-column flex-shrink ${className}`}
      pl={md && isLarge && isRight ? 7 : 0}
      pr={md && isLarge && !isRight ? 7 : 0}
      pt={!md && isLarge ? 5 : 0}
      sx={
        !md
          ? {
              "& > img": {
                position: "relative !important",
                transform: "translateX(-50%) !important",
              },
              ...sx,
            }
          : sx
      }
    >
      {children}
    </StyleBox>
  );
};

export default SideContent;
